import { getParameterFromURL } from '../../utils/scripts';

/**
 * v50/v49 paywall combos forced via URL. Intentionally reads the raw `?tariff`
 * param (not the store value): the combo is defined by the incoming link.
 */
export function isForcedLastDogTrainingPaywall(): boolean {
  const config = getParameterFromURL('config');
  const tariff = getParameterFromURL('tariff');

  return (config === 'customV50' && tariff === 'v41') || (config === 'customV49' && tariff === 'v48');
}

type MoneyBackParams = {
  tariff: string;
  lastDogTraining: boolean;
};

/** Money-back + FAQ blocks are shown for the p10 / p20 / p30 paywall families. */
export function shouldShowMoneyBack({ tariff, lastDogTraining }: MoneyBackParams): boolean {
  const mix = getParameterFromURL('mix') === 'true';
  const config = getParameterFromURL('config');

  const p20 =
    lastDogTraining ||
    ((((tariff === 'v41' || tariff === 'v42') &&
      (config === 'customV2' || config === 'customV33' || config === 'customV54')) ||
      tariff === 'v49') &&
      !mix);
  const p10 = (tariff === 'v21' || tariff === 'v22') && config === 'customV2' && !mix;
  const p30 = tariff === 'v48';

  return p20 || p10 || p30;
}

